<template>

  <div class="OrderDetail">
    <div class="main">
      <h1 v-if='orderLoaded'>{{dynamicTitle('orderDetail')}}</h1>
      <h1 v-else>Loading...</h1>

      <div class='order' v-if='order != null'>

        <p id="companyName" v-if="company != null && company.name">{{company.name}}</p>
        <p id="orderId">{{dynamicTitle('orderId')}}:    {{order.id}}</p>

        <table v-if="order != null" >
          <tbody>
          <tr id="orderCustomerRow">
            <td class="tableItemName">{{dynamicTitle('clientName')}}:</td>
            <td class="tableItemValue" v-if="order.client">{{order.client}}様</td>
          </tr>
          <tr id="destinationAddressRow" v-if="order.destination_address != null">
            <td class="tableItemName">{{dynamicTitle('destinationAddress')}}:</td>
            <td class="tableItemValue"> {{ order.destination_address }}</td>
          </tr>

          <tr id="destinationNameRow" v-if="order.destination_name != null">
            <td class="tableItemName">{{dynamicTitle('destinationName')}}:</td>
            <td class="tableItemValue"> {{ order.destination_name }}</td>
          </tr>

          <tr id="orderNameRow" v-if="order.name != null">
            <td class="tableItemName">{{dynamicTitle('orderName')}}:</td>
            <td class="tableItemValue">{{ order.name }}{{dynamicTitle('orderNamePostfix')}}</td>
          </tr>

          <tr id="driverNameRow" v-if="driver != null && driver.name != null">
            <td class="tableItemName">ドライバー:</td>
            <td class="tableItemValue">{{ driver.name }}</td>
          </tr>
          </tbody>
        </table>

        <div  id="mapTitle">▼{{dynamicTitle('visibleWhileDelivering')}}</div>


        <!-- 送迎中のマップビュー -->
        <gmap-map
          v-if="order.status == 'started'"
          id="map"
          ref="map"
          :center="{lat: center.latitude, lng: center.longitude}"
          :zoom="17"
        >
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="{lat: m.latitude, lng: m.longitude}"
            :icon="{ url: require('../assets/driver_pin@2x.png'),
          scaledSize: {width: 34, height: 40}
          }"
          ></gmap-marker>

          <gmap-marker
            :key="index + 1000"
            v-for="(m, index) in destinations"
            :position="{lat: m.latitude, lng: m.longitude}"
          ></gmap-marker>
        </gmap-map>


        <!-- 送迎準備中のときのマップビュー -->
        <div
          v-if="order.status != null && order.status != 'started'"
          id="preparingCaution">
          <p class="orderStatusTitle">{{dynamicTitle('preparing')}}</p>
          <p class="orderStatusDescription">{{dynamicTitle('afterStarted')}}<br/>ドライバーの現在位置が表示されます。</p>

          <img class="preparingCautionIcon" src="../assets/img_waiting_car.png">
        </div>

      </div>


      <!-- 送迎が完了したときの全体のビュー -->
      <div class='orderCompleted' v-if='orderLoaded && order == null'>
        <p class="orderStatusTitle">{{dynamicTitle('doneDelivering')}}</p>
        <p class="orderStatusDescription">{{dynamicTitle('deliveryCompleted')}}<br/>{{dynamicTitle('thankyou')}}</p>

      </div>

      <div class="footer" v-if='orderLoaded'>
        <div class="footer_logo_helper">
          <img class="footer_logo" src="../assets/ikude_footer_logo.png" alt="ikude">
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  import {db, fb} from '../firebase'
  import moment from 'moment'
  import {Subject, Observable, combineLatest, asyncScheduler, asapScheduler} from 'rxjs'


  const words = {
    'dayservice' : {
      'orderDetail' : '送迎の詳細',
      'orderId' : '送迎ID',
      'clientName' : 'ご契約者様',
      'destinationAddress' : '送迎先住所',
      'destinationName' : '送迎先お客様',
      'orderName' : 'ご利用者様',
      'orderNamePostfix' : '様',
      'visibleWhileDelivering' : 'ドライバーの現在地 ( 送迎を開始したら表示されます )',
      'preparing' : '送迎準備中です',
      'afterStarted' : '利用者様の送迎に出発すると',
      'doneDelivering' : '送迎完了',
      'deliveryCompleted' : 'こちらの利用者様の送迎は完了しています',
      'thankyou' : 'いつも大変ありがとうございます。'
    },
    'bike' : {
      'orderDetail' : 'ご注文の詳細',
      'orderId' : '注文ID',
      'clientName' : 'ご依頼主',
      'destinationAddress' : '配達先住所',
      'destinationName' : '配達先お客様名',
      'orderName' : 'お届け物',
      'orderNamePostfix' : '',
      'visibleWhileDelivering' : 'ドライバーの現在地 ( 配達を開始したら表示されます )',
      'preparing' : '配達準備中です',
      'afterStarted' : 'ご注文の配達に出発すると',
      'doneDelivering' : '配達完了',
      'deliveryCompleted' : 'こちらのご注文の配達は完了しています',
      'thankyou' : 'ご利用ありがとうございました。'
    },
    'default' : {
      'orderDetail' : '詳細',
      'orderId' : 'ID',
      'clientName' : 'ご依頼主',
      'destinationAddress' : '住所',
      'destinationName' : '送迎先のごお客様名、あるいは配達先のお客様名',
      'orderName' : '送迎のご利用者様、あるいは配達のお届け物',
      'orderNamePostfix' : '',
      'visibleWhileDelivering' : 'ドライバーの現在地 ( ドライバーがむかっているときだけ表示されます )',
      'preparing' : '配達準備中です',
      'afterStarted' : 'ご注文の配達に出発すると',
      'doneDelivering' : '配達完了',
      'deliveryCompleted' : 'こちらのご注文の配達は完了しています',
      'thankyou' : 'ご利用ありがとうございました。'
    }
  }

  export default {

    name: "OrderDetail",
    created () {

      console.log('created called')


      var _this = this
      this.driverFetchSubject = new Subject()
      this.destinationFetchSubject = new Subject()
      this.mapLoadSubject = new Subject()

      this.$watch('driver', function(value) {
        console.log('driver changed, and position updated')

        if (value.latitude && value.longitude) {
          _this.markers = []
          _this.markers.push({
            latitude: value.latitude,
            longitude: value.longitude
          })
        }
      })

      this.$watch('order', function (value) {
        console.log('order changed, and position updated')
        if (value.destination_latitude && value.destination_longitude) {
          _this.destinations = []
          _this.destinations.push({
            latitude: value.destination_latitude,
            longitude: value.destination_longitude
          })
        }
      })
    },
    mounted () {
      this.geolocate();
      this.getOrder()

      let _this = this




      this.subscription = combineLatest(this.driverFetchSubject, this.destinationFetchSubject, this.mapLoadSubject).subscribe(
        () => {
          console.log('combineLatest')

          if(!_this.isDirectionLoaded ){
            _this.getDirections()
          }
        }
      );
    },

    updated () {
      let _this = this

      if(this.isMapLoaded === false){

        // ビュー全体がレンダリングされた後にのみ実行されるコード

        /* マップオブジェクトを取得(mountedでやると、まだthis.$refs.mapがnull */
        if(this.$refs.map != null){
          console.log("map is not null");

          this.isMapLoaded = true

          this.$refs.map.$mapPromise.then((map) => {




            if(this.markers.length > 0 && this.destinations.length > 0){
              let bounds  = new google.maps.LatLngBounds();
              let locDriver = new google.maps.LatLng(this.markers[0].latitude, this.markers[0].longitude);
              bounds.extend(locDriver);
              let locDestination = new google.maps.LatLng(this.destinations[0].latitude, this.destinations[0].longitude);
              bounds.extend(locDestination);

              if(this.isAutoZoomDoneOnce === false){
                console.log('auto zoom (first time)', bounds)
                map.fitBounds(bounds);       //auto-zoom
                map.panToBounds(bounds);       // auto-center

                this.isAutoZoomDoneOnce = true
              }else if(map.getBounds().contains(locDriver) === false){
                console.log('auto zoom c/z driver is out of the map bounds', bounds)
                map.fitBounds(bounds);       //auto-zoom
                map.panToBounds(bounds);       // auto-center
              }
            }else{
              console.log('either destination or driver position not available')
              if(this.destinations.length > 0){


                this.center = {latitude: this.destinations[0].latitude, longitude: this.destinations[0].longitude}

              }else if(this.markers.length > 0){
                this.center = {latitude: this.markers[0].latitude, longitude: this.markers[0].longitude}
                console.log('move to driver', this.center)
              }
            }

            console.log("mapLoadSubject.next()");
            _this.mapLoadSubject.next()
          })
        }else{
          console.log("map is null");

        }

      }

      /*
      this.$nextTick(function () {

      })
      */
    },

    data () {
      return {
        order: null,
        driver: null,
        company: null,
        //position: null,
        devMes: null,

        center: { latitude: 45.508, longitude: -73.587 },
        markers: [],
        destinations: [],

        isAutoZoomDoneOnce: false,

        orderLoaded: false,

        driverFetchSubject: null,
        destinationFetchSubject: null,
        mapLoadSubject: null,
        subscription: null,
        isDirectionLoaded: false,

        isMapLoaded: false
      }
    },

    props: {
      zoom: {
        type: Number,
        default: 16
      },

    },

    computed: {

      trackingDatetime: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']
          if(tracking != null){
            let date = tracking['datetime'].toDate()
            return moment(date).format('HH:mm, YYYY/MM/DD')
          }
          return ""
        };
      },

    },

    methods: {

      // receives a place object via the autocomplete component
      setPlace(place) {

      },


      getOrder () {
        var _this = this

        this.$bind('order', db.collection('companies').doc(this.$route.params.company_id).collection('orders').doc(this.$route.params.id)).then(order => {
          this.orderLoaded = true

          console.log("destinationFetchSubject.next()");
          this.destinationFetchSubject.next()

          if (_this.company == null) {
            console.log("getCompany");
            _this.getCompany()
          }

          if (_this.driver == null) {
            _this.getDriver()
          }
        })


      },
      getDriver () {
        this.$bind('driver', db.collection('companies').doc(this.$route.params.company_id).collection('drivers').doc(this.order.driver_id)).then(driver => {
          //this.$unbind('driver')

          console.log("driverFetchSubject.next()");
          this.driverFetchSubject.next()
        })

      },
      getCompany () {
        this.$bind('company', db.collection('companies').doc(this.$route.params.company_id)).then(company => {
          this.$unbind('company')
        })
      },

      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
        });
      },


      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.company){
          let type = this.company.type
          let wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      },


      getDirections: function() {

        if(this.markers.length > 0 && this.destinations.length > 0){
          let start = {lat: this.markers[0].latitude, lng: this.markers[0].longitude}
          let destination = {lat: this.destinations[0].latitude, lng: this.destinations[0].longitude}

          var directionsService = new google.maps.DirectionsService;
          var directionsDisplay = new google.maps.DirectionsRenderer(
            {
              suppressMarkers: true
            });
          directionsDisplay.setMap(this.$refs.map.$mapObject);

          //google maps API's direction service
          function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
            directionsService.route({
              origin: start,
              destination: destination,
              travelMode: 'DRIVING'
            }, function(response, status) {
              if (status === 'OK') {
                directionsDisplay.setDirections(response);
              } else {
                window.alert('Directions request failed due to ' + status);
              }
            });
          }

          console.log(start);
          console.log(destination);
          //console.log('hmmm yha');
          calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination);

          this.isDirectionLoaded = true
        }
      }
    }


  }
</script>

<style scoped>
  .OrderDetail{
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #FFFFFF;
  }

  .OrderDetail h1{
    color: #5C5C5C;
    font-size: 17px;
    font-weight: normal;
    margin: 0 0 0 0;
    background-color: #F3F3F3;
    height: 34px;
    line-height: 34px;
    padding-top: 4px;
  }

  .main {
    width: 100%;
  }

  h1, h2 {
    font-weight: normal;
  }
  a {
    color: #42b983;
  }

  .order {
    width: auto;
    height: 100%;
    text-align: center;

    margin-top: 15px;
  }

  .order table {
    color: #5C5C5C;
    font-size: 13px;
    font-weight: lighter;
    margin-left: 4%;
    margin-right: 4%;
  }


  #companyName {
    color: #5C5C5C;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 0;
  }

  #orderId{
    color: #5C5C5C;
    font-size: 10px;
    font-weight: lighter;
    margin-top: 0;
    margin-bottom: 12px;
  }

  #orderCustomerRow {

  }



  .tableItemName {
    text-align: right;
    vertical-align: top;
    padding-bottom: 2px;
    width: 100px;
  }

  .tableItemValue {
    text-align: left;
    padding-left: 20px;
    padding-bottom: 2px;
    vertical-align: top;
  }

  #destinationAddressRow .tableItemValue{
    padding-bottom: 0;
  }

  #destinationAddressRow .tableItemName{
    padding-bottom: 0;
  }

  #mapTitle {
    color: #5C5C5C;
    font-size: 13px;
    margin-top: 20px;
    margin-bottom: 2px;
  }


  #map {
    width: 100%;
    height: 450px;
  }


  .footer {
    display: table;
    width: 100%;
    height: 21px;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    background-color: #666666;
  }

  .footer_logo_helper {
    display: table-cell;
    width: 100px;
    height: 15px;
    vertical-align: middle;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  .footer_logo{
    width: 50px;
    height: 15px;
    vertical-align: top;
    padding: 0;
    margin: 0;
  }


  #preparingCaution {
    width: 100%;
    height: 600px;
    background: #F2F2F2 url('../assets/img_waiting_bg.png') no-repeat center;
    background-size: cover;
  }

  .preparingCautionIcon {
    width: 36%;
    height: auto;
    margin-top: 40px;
  }





  .orderStatusTitle {
    color: #707070;
    font-size: 22px;
    font-weight: bold;
    padding-top: 44px;
    margin-bottom: 20px;
  }

  .orderStatusDescription {
    color: #707070;
    font-size: 16px;
    font-weight: bold;
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }


  .orderCompleted {
    width: auto;
    height: 600px;
    text-align: center;
    margin-top: 15px;
  }


</style>



// WEBPACK FOOTER //
// src/pages/Order.vue